var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Search_results_for_Information_-_Flaticon-2",
    "data-name": "Search results for Information - Flaticon-2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#339dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1362b1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_225510",
    "data-name": "Group 225510"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_280029",
    "data-name": "Path 280029",
    d: "M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm2.082,15.5q-.772.3-1.232.464a3.249,3.249,0,0,1-1.068.16,2.129,2.129,0,0,1-1.454-.456,1.472,1.472,0,0,1-.517-1.157,4.2,4.2,0,0,1,.038-.558c.026-.19.068-.4.124-.643l.644-2.276c.057-.218.106-.426.145-.619a2.744,2.744,0,0,0,.058-.536.825.825,0,0,0-.179-.607,1.019,1.019,0,0,0-.688-.17,1.806,1.806,0,0,0-.512.076c-.174.053-.324.1-.448.149l.17-.7q.632-.258,1.211-.441A3.576,3.576,0,0,1,9.465,8a2.09,2.09,0,0,1,1.432.449,1.491,1.491,0,0,1,.5,1.165q0,.149-.035.522a3.5,3.5,0,0,1-.129.687L10.6,13.09c-.052.182-.1.39-.141.623a3.3,3.3,0,0,0-.062.53.761.761,0,0,0,.2.616,1.133,1.133,0,0,0,.7.164,2.031,2.031,0,0,0,.53-.082,3.013,3.013,0,0,0,.428-.144Zm-.113-9.209a1.529,1.529,0,0,1-1.079.417A1.545,1.545,0,0,1,9.8,6.289a1.33,1.33,0,0,1-.451-1.01A1.343,1.343,0,0,1,9.8,4.267a1.534,1.534,0,0,1,1.084-.421,1.517,1.517,0,0,1,1.079.421,1.364,1.364,0,0,1,0,2.022Z",
    fill: "#036822"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8e7a95c85b33f01b32b3e529fb9bde88.svg";
export { ForwardRef as ReactComponent };